var map = {
	"./GlobalsImport.js": "Jea5",
	"./ServerStatus.vue": "ZzQ3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gnvq";


//////////////////
// WEBPACK FOOTER
// ./src/components/globals nonrecursive [A-Z]\w+\.(vue|js)$
// module id = gnvq
// module chunks = 9